import api from '../../services/api'

export default {
  actions: {
    createProductLoginCookie ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        api.get(`products/getJWT/${payload.token}`, {
          withCredentials: true
        })
          .then(() => {
            resolve(true);
          })
          .catch(err => {
            commit('setError', err.response || err)
            try {
              reject(err.response.data.error)
            } catch (e) {
              reject(err)
            }
          })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/productLoginToken/index.js